function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 474.69998,
    height: 182.7,
    viewBox: "-48.5 305.9 474.69999 182.69999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.0616,0.05349619)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.8,685.5984)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -284.3,-197.1 h 73.1 l -73.1,-73.1 v 73.1 z",
    style: {
      fill: "#d9003d",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372.1851,738.0545)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 54.2,-432.2 h -73.1 l 73.1,73.1 v -73.1 z",
    style: {
      fill: "#d9003d",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(265.1752,698.1882)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -211.4,-253.5 43.8,43.8 h 73 l -43.8,-43.8 h -73 z",
    style: {
      fill: "#d9003d",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(235.8,738.0549)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -284.3,-432.2 v 36.5 l 43.8,43.8 v -36.5 h 36.5 l -43.8,-43.8 h -36.5 z",
    style: {
      fill: "#d9003d",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372.1851,696.0897)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 54.2,-244.1 -43.8,-43.8 v 36.5 h -36.5 l 43.8,43.8 h 36.5 l 0,0 v -36.5 z",
    style: {
      fill: "#d9003d",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(342.8096,725.4651)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -18.7,-375.8 -43.8,-43.8 h -73.1 l 43.8,43.8 h 73.1 z",
    style: {
      fill: "#d9003d",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300.8453,725.4651)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -122.9,-375.8 -43.8,-43.8 h -73.1 l 43.8,43.8 h 73.1 z",
    style: {
      fill: "#d9003d",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(307.1397,698.1882)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -107.3,-253.5 43.8,43.8 H 9.6 l -43.8,-43.8 h -73.1 z",
    style: {
      fill: "#d9003d",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.8646,716.0859)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -157.6,-333.7 c -1.5,-1.3 -3.6,-2 -6.2,-2 h -7.7 v 15.9 h 7.7 c 2.7,0 4.7,-0.7 6.2,-2.1 1.5,-1.4 2.2,-3.3 2.2,-5.8 v -0.2 c 0.1,-2.6 -0.6,-4.5 -2.2,-5.8",
    style: {
      fill: "#ffffff",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.7321,709.829)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -73.5,-305.7 h 11.3 l -5.7,-17.8 -5.6,17.8 z",
    style: {
      fill: "#ffffff",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(345.0616,703.4465)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -13.2,-277.1 c -4.2,-1.4 -8.1,-3.7 -11.7,-6.8 l 8.3,-11.4 c 2.5,2 5.1,3.7 7.9,5 2.8,1.3 5.7,1.9 8.6,1.9 2.1,0 3.7,-0.4 4.7,-1.2 1.1,-0.8 1.6,-1.9 1.6,-3.2 v -0.1 c 0,-0.6 -0.1,-1.1 -0.4,-1.7 -0.3,-0.5 -0.7,-1 -1.4,-1.5 -0.7,-0.5 -1.6,-1 -2.7,-1.5 -1.2,-0.5 -2.6,-1.1 -4.4,-1.7 -2.9,-1 -5.5,-2 -7.9,-3.1 -2.4,-1.1 -4.4,-2.3 -6.2,-3.8 -1.7,-1.5 -3.1,-3.2 -4,-5.1 -1,-2 -1.4,-4.3 -1.4,-7.1 v -0.3 c 0,-2.8 0.5,-5.3 1.5,-7.6 1,-2.3 2.5,-4.3 4.3,-5.9 1.9,-1.7 4.2,-2.9 6.9,-3.9 2.7,-0.9 5.7,-1.4 9,-1.4 4.1,0 8,0.6 11.6,1.7 3.6,1.2 7,3 10.2,5.7 l -7.9,11.7 c -2.1,-1.6 -4.3,-3 -6.8,-4 -2.4,-1 -4.9,-1.6 -7.4,-1.6 -1.8,0 -3.2,0.4 -4.1,1.1 -1,0.8 -1.4,1.7 -1.4,2.9 v 0.1 c 0,0.7 0.1,1.3 0.4,1.8 0.3,0.5 0.8,1 1.5,1.6 0.7,0.5 1.7,1.1 3,1.7 1.2,0.6 2.8,1.2 4.7,1.9 2.9,0.9 5.5,1.9 7.8,3 2.3,1.1 4.3,2.4 5.9,3.9 1.6,1.5 2.9,3.2 3.7,5.1 0.9,1.9 1.3,4.2 1.3,6.8 v 0.2 c 0,3 -0.6,5.6 -1.7,8 -1.1,2.4 -2.6,4.4 -4.6,6 -1.9,1.7 -4.3,2.9 -7,3.8 -2.7,0.9 -5.7,1.3 -9,1.3 -4.3,-0.1 -8.7,-0.9 -12.9,-2.3 m -26.4,-21.7 v 23 h -15.7 v -22.8 l -19.6,-38.1 h 17.3 l 10.2,22 10.3,-22 h 17 c 0,0 -19.5,37.9 -19.5,37.9 z m -39.5,23 -3.6,-11 h -19.1 l -3.5,11 h -16.1 L -100,-337 h 15.8 l 21.5,61.2 c 0.1,0 -16.4,0 -16.4,0 z m -57,-2.2 c -3.9,1.4 -8.2,2.2 -13.2,2.2 H -169 v -60.9 h 20 c 4.9,0 9.2,0.7 13,2.1 3.8,1.4 7,3.4 9.7,6 2.6,2.6 4.6,5.7 6,9.4 1.4,3.7 2,7.7 2,12.2 v 1 c 0,4.5 -0.7,8.6 -2,12.3 -1.4,3.7 -3.4,6.9 -6,9.5 -2.7,2.7 -5.9,4.8 -9.8,6.2 m -40.5,2.2 h -15.7 v -60.9 h 15.7 c 0,0 0,60.9 0,60.9 z m -37.1,0 -10.3,-18.9 h -5.6 v 18.9 h -15.6 v -60.9 h 23.9 c 8.2,0 14.3,2.1 18.3,6.2 1.7,1.7 3,3.7 3.9,6 0.9,2.4 1.4,5.1 1.4,8.2 v 0.4 c 0,4.5 -1,8.2 -3,11.1 -2,2.9 -4.6,5.2 -7.9,6.8 l 12.5,22.1 h -17.6 l 0,0.1 z m -36.2,-46.8 h -25.7 v 10.8 h 23.1 v 13.5 h -23.1 v 22.5 h -15.7 v -60.9 h 41.4 c 0,0 0,14.1 0,14.1 z m -67.2,24.5 h -0.6 c -9.1,0 -15.5,-6.3 -15.5,-14.7 0,-4.4 1.3,-7.5 3.7,-10.5 l 6,4.4 c -1.4,1.6 -2.5,3.4 -2.5,6 0,3.9 3.4,6.8 8.4,6.8 h 0.4 c 5.6,0 8.7,-3 8.7,-6.9 0,-1.5 -0.3,-2.7 -0.9,-3.5 h -4.5 v 4.8 h -6.1 v -12.2 h 14.5 c 2.1,2.9 3.8,6.6 3.8,11.2 0,8.3 -5.9,14.6 -15.4,14.6 m 14.9,15.6 h -23.4 v 7.5 h -7.1 v -22.9 h 7.1 v 7.5 h 23.4 l 0,7.9 0,0 z m -30.5,-54.2 h 30.5 v 7.8 h -30.5 v -7.8 z m 370.1,77.9 v -36.5 l 43.8,43.8 v -73.1 l -73,-73 h -73.1 l 43.8,43.8 H -94 l -43.8,-43.8 h -73 l 43.8,43.8 h -73.1 l -43.8,-43.8 H -357 l 43.8,43.8 h -36.5 v 36.5 l -43.8,-43.8 v 73.1 l 73.1,73.1 h 73.1 l -43.8,-43.8 h 73.1 l 43.8,43.8 h 73.1 l -43.8,-43.8 h 73.1 l 43.8,43.8 H 45.1 L 0.9,-258.8 h 36.5 l 0,0 z",
    style: {
      fill: "#ffffff",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(306.0916,716.548)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -109.9,-335.8 h -4.5 v 32.9 h 4.5 c 4.3,0 7.9,-1.3 10.5,-3.9 2.7,-2.6 4,-6.6 4,-12.1 v -0.8 c 0,-5.5 -1.3,-9.6 -4,-12.2 -2.6,-2.6 -6.1,-3.9 -10.5,-3.9",
    style: {
      fill: "#ffffff",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(265.1671,703.0847)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -211.4,-275.5 h 15.7 V -298 h 23.1 v -13.5 h -23.1 v -10.8 h 25.7 v -14.1 h -41.4 v 60.9 z",
    style: {
      stroke: "none",
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(287.5263,714.3502)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -155.9,-325.9 c 0,2.4 -0.7,4.4 -2.2,5.8 -1.5,1.4 -3.6,2.1 -6.2,2.1 h -7.7 v -15.9 h 7.7 c 2.6,0 4.7,0.7 6.2,2 1.5,1.3 2.3,3.3 2.3,5.9 v 0.1 z m 12.7,10.3 c 2,-2.9 3,-6.6 3,-11.1 v -0.4 c 0,-3.1 -0.5,-5.9 -1.4,-8.2 -0.9,-2.4 -2.2,-4.4 -3.9,-6 -4,-4.1 -10.1,-6.2 -18.3,-6.2 h -23.9 v 60.9 h 15.6 v -18.9 h 5.6 l 10.3,18.9 h 17.7 l -12.5,-22.1 c 3.2,-1.7 5.8,-4 7.8,-6.9",
    style: {
      stroke: "none",
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 152.8,427.6 h 15.7 v -60.9 h -15.7 v 60.9 z",
    style: {
      stroke: "none",
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310.2628,711.7025)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -99.5,-314.1 c 0,5.5 -1.3,9.5 -4,12.1 -2.7,2.6 -6.2,3.9 -10.5,3.9 h -4.5 V -331 h 4.5 c 4.3,0 7.9,1.3 10.5,3.9 2.7,2.6 4,6.7 4,12.2 v 0.8 z m 16,-0.1 v -1 c 0,-4.5 -0.7,-8.5 -2,-12.2 -1.4,-3.7 -3.3,-6.8 -6,-9.4 -2.6,-2.6 -5.8,-4.6 -9.7,-6 -3.8,-1.4 -8.2,-2.1 -13,-2.1 h -20 v 60.9 h 19.7 c 4.9,0 9.3,-0.7 13.2,-2.2 3.9,-1.4 7.1,-3.5 9.7,-6.1 2.6,-2.6 4.6,-5.8 6,-9.5 1.4,-3.8 2.1,-7.9 2.1,-12.4",
    style: {
      stroke: "none",
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.7321,709.829)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -73.5,-305.7 5.7,-17.8 5.7,17.8 h -11.4 z m -2.1,-37.7 -21.4,61.2 h 16.1 l 3.5,-11 h 19.1 l 3.6,11 h 16.4 l -21.5,-61.2 c 0,0 -15.8,0 -15.8,0 z",
    style: {
      stroke: "none",
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(338.18,720.5696)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -30.2,-353.8 -10.3,22 -10.2,-22 H -68 l 19.6,38.1 v 22.8 h 15.7 v -23 l 19.6,-37.9 h -17.1 z",
    style: {
      stroke: "none",
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(353.4046,704.2957)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 7.5,-280.9 c 1.9,-1.7 3.5,-3.7 4.6,-6 1.1,-2.3 1.7,-5 1.7,-8 v -0.2 c 0,-2.6 -0.4,-4.9 -1.3,-6.8 -0.9,-1.9 -2.1,-3.6 -3.7,-5.1 -1.6,-1.5 -3.6,-2.8 -5.9,-3.9 -2.3,-1.1 -4.9,-2.1 -7.8,-3 -1.9,-0.7 -3.5,-1.3 -4.7,-1.9 -1.2,-0.6 -2.2,-1.1 -3,-1.7 -0.7,-0.5 -1.2,-1 -1.5,-1.6 -0.3,-0.5 -0.4,-1.1 -0.4,-1.8 v -0.1 c 0,-1.2 0.5,-2.1 1.4,-2.9 1,-0.8 2.3,-1.1 4.1,-1.1 2.5,0 5,0.5 7.4,1.6 2.4,1 4.7,2.4 6.8,4 L 13,-331 c -3.2,-2.6 -6.6,-4.5 -10.2,-5.7 -3.6,-1.2 -7.4,-1.7 -11.6,-1.7 -3.3,0 -6.3,0.5 -9,1.4 -2.7,0.9 -5,2.2 -6.9,3.9 -1.9,1.7 -3.3,3.6 -4.3,5.9 -1,2.3 -1.5,4.8 -1.5,7.6 v 0.3 c 0,2.8 0.5,5.2 1.4,7.1 1,2 2.3,3.7 4,5.1 1.7,1.4 3.8,2.7 6.2,3.8 2.4,1.1 5,2.1 7.9,3.1 1.8,0.6 3.3,1.2 4.4,1.7 1.2,0.5 2.1,1 2.7,1.5 0.7,0.5 1.1,1 1.4,1.5 0.3,0.5 0.4,1.1 0.4,1.7 v 0.1 c 0,1.3 -0.5,2.4 -1.6,3.2 -1.1,0.8 -2.7,1.2 -4.7,1.2 -3,0 -5.8,-0.6 -8.6,-1.9 -2.8,-1.3 -5.4,-2.9 -7.9,-5 l -8.3,11.4 c 3.6,3.1 7.5,5.4 11.7,6.8 4.2,1.4 8.6,2.1 13.1,2.1 3.2,0 6.2,-0.4 9,-1.3 2.7,-0.8 5,-2 6.9,-3.7",
    style: {
      stroke: "none",
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(255.3112,709.4133)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -235.9,-303.8 h -7.1 v 22.9 h 7.1 v -7.5 h 23.4 v -7.8 h -23.4 v -7.6 z",
    style: {
      stroke: "none",
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.9248,716.9022)",
    style: {
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -231.9,-337.4 v 12.2 h 6.1 v -4.8 h 4.5 c 0.6,0.9 0.9,2 0.9,3.5 0,3.9 -3.1,6.9 -8.7,6.9 h -0.4 c -5.1,0 -8.4,-3 -8.4,-6.8 0,-2.6 1.1,-4.4 2.5,-6 l -6,-4.4 c -2.4,3 -3.7,6.1 -3.7,10.5 0,8.4 6.4,14.7 15.5,14.7 h 0.6 c 9.5,0 15.4,-6.3 15.4,-14.6 0,-4.6 -1.7,-8.3 -3.8,-11.2 h -14.5 z",
    style: {
      stroke: "none",
      fill: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 42.9,366.8 H 12.4 v 7.8 h 30.5 v -7.8 z",
    style: {
      stroke: "none",
      fill: "#000000"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgif);
export default __webpack_public_path__ + "static/media/tgif.02cf78e0f7243d44c4b89d23719ca723.svg";
export { ForwardRef as ReactComponent };